import Calendar from './Calendar.vue';

export default Calendar;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/views/calendar/index.ts